export const managerRoles = ['OWNER', 'ADMIN', 'MODERATOR']
